import * as React from "react";
import { forwardRef } from "react";
const SvgUnchecked = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 19, viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 1, width: 17, height: 17, rx: 1.5, stroke: "#979797" }));
const ForwardRef = forwardRef(SvgUnchecked);
export default ForwardRef;
